module.exports = __webpack_public_path__ + "img/23_25.7ad7a148.png";